import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const VoyahDreamAdaptedEditor = () => {
  const [form, setForm] = useState({
    // LEFT TITLE
    LeftTitleEn: "",
    LeftTitleAr: "",
    LeftTitleKu: "",

    // RIGHT DESCRIPTION
    RightDescEn: "",
    RightDescAr: "",
    RightDescKu: "",

    // SPEC 1
    Spec1LabelEn: "",
    Spec1LabelAr: "",
    Spec1LabelKu: "",
    Spec1ValueEn: "",
    Spec1ValueAr: "",
    Spec1ValueKu: "",

    // SPEC 2
    Spec2LabelEn: "",
    Spec2LabelAr: "",
    Spec2LabelKu: "",
    Spec2ValueEn: "",
    Spec2ValueAr: "",
    Spec2ValueKu: "",

    // SPEC 3
    Spec3LabelEn: "",
    Spec3LabelAr: "",
    Spec3LabelKu: "",
    Spec3ValueEn: "",
    Spec3ValueAr: "",
    Spec3ValueKu: "",

    // SPEC 4
    Spec4LabelEn: "",
    Spec4LabelAr: "",
    Spec4LabelKu: "",
    Spec4ValueEn: "",
    Spec4ValueAr: "",
    Spec4ValueKu: "",
  });

  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(true);

  // Modal
  const [showModal, setShowModal] = useState(false);
  const [uploadFile, setUploadFile] = useState(null);

  const resolveUrl = (u) =>
    u?.startsWith("http") ? u : `${API_BASE}${u}`;

  const LANGS = ["En", "Ar", "Ku"];

  // ============================================================
  // LOAD DATA (3 LANGUAGES)
  // ============================================================
  useEffect(() => {
    const load = async () => {
      try {
        const [en, ar, ku] = await Promise.all([
          axios.get(`${API_BASE}/api/VoyahDreamAdaptedSection?lang=en`),
          axios.get(`${API_BASE}/api/VoyahDreamAdaptedSection?lang=ar`),
          axios.get(`${API_BASE}/api/VoyahDreamAdaptedSection?lang=ku`),
        ]);

        setForm({
          // LEFT TITLE
          LeftTitleEn: en.data.leftTitle,
          LeftTitleAr: ar.data.leftTitle,
          LeftTitleKu: ku.data.leftTitle,

          // RIGHT DESCRIPTION
          RightDescEn: en.data.rightDescription,
          RightDescAr: ar.data.rightDescription,
          RightDescKu: ku.data.rightDescription,

          // SPEC VALUES + LABELS
          Spec1ValueEn: en.data.spec1Value,
          Spec1ValueAr: ar.data.spec1Value,
          Spec1ValueKu: ku.data.spec1Value,

          Spec1LabelEn: en.data.spec1Label,
          Spec1LabelAr: ar.data.spec1Label,
          Spec1LabelKu: ku.data.spec1Label,

          Spec2ValueEn: en.data.spec2Value,
          Spec2ValueAr: ar.data.spec2Value,
          Spec2ValueKu: ku.data.spec2Value,

          Spec2LabelEn: en.data.spec2Label,
          Spec2LabelAr: ar.data.spec2Label,
          Spec2LabelKu: ku.data.spec2Label,

          Spec3ValueEn: en.data.spec3Value,
          Spec3ValueAr: ar.data.spec3Value,
          Spec3ValueKu: ku.data.spec3Value,

          Spec3LabelEn: en.data.spec3Label,
          Spec3LabelAr: ar.data.spec3Label,
          Spec3LabelKu: ku.data.spec3Label,

          Spec4ValueEn: en.data.spec4Value,
          Spec4ValueAr: ar.data.spec4Value,
          Spec4ValueKu: ku.data.spec4Value,

          Spec4LabelEn: en.data.spec4Label,
          Spec4LabelAr: ar.data.spec4Label,
          Spec4LabelKu: ku.data.spec4Label,
        });

        setImage(en.data.imageUrl);
        setLoading(false);
      } catch (err) {
        console.error("Failed to load Dream Adapted section:", err);
      }
    };

    load();
  }, []);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  // ============================================================
  // SAVE TEXTS (NOW MATCHES DTO EXACTLY)
  // ============================================================
  const handleSave = async () => {
    const token = localStorage.getItem("token");

    try {
      await axios.put(`${API_BASE}/api/VoyahDreamAdaptedSection`, form, {
        headers: { Authorization: `Bearer ${token}` },
      });

      alert("Saved successfully!");
    } catch (err) {
      console.error("SAVE FAILED", err);
      alert("Failed to save.");
    }
  };

  // ============================================================
  // DELETE IMAGE
  // ============================================================
  const deleteImage = async () => {
    if (!image) return alert("No image to delete.");

    const token = localStorage.getItem("token");

    try {
      await axios.delete(`${API_BASE}/api/VoyahDreamAdaptedSection/image`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { url: image },
      });

      alert("Image deleted!");
      window.location.reload();
    } catch (err) {
      console.error(err);
      alert("Delete failed.");
    }
  };

  // ============================================================
  // UPLOAD IMAGE
  // ============================================================
  const handleUpload = async () => {
    if (!uploadFile) return alert("Select a file first.");

    const token = localStorage.getItem("token");
    const fd = new FormData();
    fd.append("Image", uploadFile);

    try {
      await axios.put(`${API_BASE}/api/VoyahDreamAdaptedSection/image`, fd, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      alert("Image updated!");
      setShowModal(false);
      window.location.reload();
    } catch (err) {
      console.error("UPLOAD FAILED", err);
      alert("Upload failed.");
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div className="container py-4">
      <h2 className="fw-bold mb-4">VOYAH DREAM – Adapted Section Editor</h2>

      {/* ============================================================
          TEXT FIELDS (3 LANGUAGE GROUPS)
      ============================================================ */}
      <div className="row">
        {LANGS.map((lang) => (
          <div key={lang} className="col-lg-4 col-md-6 mb-4">
            <div className="card shadow-sm border-0 h-100">
              <div className="card-body">
                <h5 className="text-primary">{lang}</h5>

                {/* LEFT TITLE */}
                <label className="form-label mt-3">Left Title</label>
                <input
                  className="form-control mb-2"
                  name={`LeftTitle${lang}`}
                  value={form[`LeftTitle${lang}`]}
                  onChange={handleChange}
                />

                {/* RIGHT DESCRIPTION */}
                <label className="form-label">Right Description</label>
                <textarea
                  className="form-control mb-3"
                  name={`RightDesc${lang}`}
                  rows={3}
                  value={form[`RightDesc${lang}`]}
                  onChange={handleChange}
                />

                {/* SPECS */}
                <h6 className="fw-bold mt-3">Specifications</h6>

                {[1, 2, 3, 4].map((spec) => (
                  <div key={spec} className="mb-3">
                    <label className="form-label">Spec {spec} Label</label>
                    <input
                      className="form-control mb-2"
                      name={`Spec${spec}Label${lang}`}
                      value={form[`Spec${spec}Label${lang}`]}
                      onChange={handleChange}
                    />

                    {/* Only EN has values */}
                    {lang === "En" && (
                      <>
                        <label className="form-label">
                          Spec {spec} Value
                        </label>
                        <input
                          className="form-control"
                          name={`Spec${spec}ValueEn`}
                          value={form[`Spec${spec}ValueEn`]}
                          onChange={handleChange}
                        />
                      </>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* SAVE BUTTON */}
      <div className="text-end mb-4">
        <button className="btn btn-primary px-4" onClick={handleSave}>
          Save Changes
        </button>
      </div>

      {/* ============================================================
          IMAGE BLOCK
      ============================================================ */}
      <h4 className="mb-3">Image</h4>

      <div className="card shadow-sm border-0 mb-4">
        <div className="card-body">
          {image ? (
            <img
              src={resolveUrl(image)}
              className="w-100 rounded mb-3"
              style={{ maxHeight: "260px", objectFit: "cover" }}
              alt=""
            />
          ) : (
            <p>No image uploaded.</p>
          )}

          <div className="d-flex gap-2">
            <button
              className="btn btn-danger"
              disabled={!image}
              onClick={deleteImage}
            >
              Delete
            </button>

            <button
              className="btn btn-primary"
              onClick={() => {
                setUploadFile(null);
                setShowModal(true);
              }}
            >
              Upload / Replace
            </button>
          </div>
        </div>
      </div>

      {/* ============================================================
          IMAGE UPLOAD MODAL
      ============================================================ */}
      {showModal && (
        <>
          <div className="modal fade show" style={{ display: "block" }}>
            <div className="modal-dialog">
              <div className="modal-content shadow">
                <div className="modal-header">
                  <h5 className="modal-title">Upload Image</h5>
                  <button
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                  />
                </div>

                <div className="modal-body">
                  <input
                    type="file"
                    accept="image/*"
                    className="form-control"
                    onChange={(e) => setUploadFile(e.target.files[0])}
                  />
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>

                  <button className="btn btn-primary" onClick={handleUpload}>
                    Upload
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </div>
  );
};

export default VoyahDreamAdaptedEditor;
